//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters } from 'vuex';

export default {
  name: 'ProductPreview',
  components: {
    PreviewSmallVideo: () => import('@motionelements/catalog/src/modules/product/preview/PreviewSmallVideo.vue'),
    PreviewVr: () => import('@motionelements/catalog/src/modules/product/preview/PreviewVr.vue'),
    // PreviewAudio: () => import('@motionelements/catalog/src/modules/product/preview/PreviewAudio.vue'),
    PreviewAudio: () => import('@motionelements/product2025/src/components/preview/PreviewAudio.vue'),
    PreviewShadow: () => import('@motionelements/product2025/src/components/PreviewShadow.vue'),
  },
  computed: {
    ...mapState({
      product: state => state.product.current,
    }),
    ...mapGetters({
      previewType: 'product/previewType',
    }),
  },
};
